import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { ticketAtom } from "../../store";
import TicketStatusItem from "../TicketStatusItem";
import styles from "./styles.module.css";
import useStatusSnippets from "../../hooks/useStatusSnippets";

const TicketStatusContainer: React.FC = () => {
  const [data] = useAtom(ticketAtom);

  const snippets = useStatusSnippets();

  useEffect(() => {
    if (data?.ticket_id) {
      snippets.fetch(data.ticket_id);
    }
  }, [data]);

  return (
    <div className={styles.ticketStatusContainer}>
      <h3>Status Lifecycle</h3>
      <div>
        {snippets.data?.data?.status_progress?.map((item: any, idx: any) => {
          return (
            <TicketStatusItem
              key={idx}
              title={item.StatusName}
              body={item.create_time || "--"}
              index={idx + 1}
              isDone={item.has_status_updated}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TicketStatusContainer;
